export default {
  getLectureCategory: '/lecture/api/mini/course/category', // [3.0]健康讲堂分类列表
  getLectureGeneralInfo: '/lecture/api/mini/course/general/page', // [3.0]通用健康讲堂内容列表，可传递展示位置节点
  getLectureCourseInfo: '/lecture/api/mini/course/courses/page', // [3.0]健康讲堂素材列表
  getLectureDoctorInfo: '/lecture/api/mini/course/doctor/page', // [3.0]医生健康讲堂内容列表，可传递展示位置节点
  getLectureArticleDetail: '/lecture/api/v3/courses/article/{0}', // [3.0]查询健康科普详情（文章）
  getLectureGeneralDetail: '/lecture/api/v3/courses/general/{0}', // [3.0]查询健康科普详情（普通课程）
  getLectureVideoDetail: '/lecture/api/v3/courses/video/{0}' // [3.0]查询健康科普详情（视频）
};
